import styled from 'styled-components';

export const Container = styled.div`
  justify-self: center;
  margin: 50px 0;
`;
